<!-- src/App.vue -->
<template>
  <!-- 这里是全局布局 -->
  <router-view :key="$route.fullPath" />
</template>

<script>
export default {
  name: 'App'
}
</script>